/**
 * Google Maps settings rendered by the layout into `window.Laravel.googleMaps`
 * (see config/services.php → google).
 *
 * @returns {{ apiKey: string, mapId: string, language: string, region: string, allowedCountries: string[], checkLocationUrl: string }}
 */
export function googleMapsConfig() {
    const config = window.Laravel?.googleMaps ?? {};

    return {
        apiKey: config.apiKey ?? '',
        checkLocationUrl: config.checkLocationUrl ?? '/api/v1/shared/geo/check-location',
        mapId: config.mapId || 'DEMO_MAP_ID',
        language: config.language ?? 'ar',
        region: config.region ?? 'SA',
        allowedCountries: config.allowedCountries ?? [],
    };
}
